export default __webpack_public_path__ + "images/Sagittal_View_for_CRL_and_NC_Measurements_dark.e36b22b556b914112ceeaef977136ad7.png";